module.exports = __webpack_public_path__ + "img/2024_LongSleeve.3f4eb313.jpg";